import Vue from 'vue'
import Vuex from 'vuex'
import trainConfirm from './modules/trainConfirm'
import official from './modules/official'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: { trainConfirm, official },
  state: {
    candidateInfo: null,
    // opera\QQ浏览器文件上传引导至其他浏览器
    agentUploadErr:
      navigator.userAgent.includes('Presto') ||
      (navigator.userAgent.includes('QQ') &&
        !navigator.userAgent.includes('MicroMessenger/')),
  },
  mutations: {
    setCandidateInfo(state, candidateInfo) {
      state.candidateInfo = candidateInfo
    },
  },
  actions: {},
})
